import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchActivities, fetchBerthrotationByJobId } from "../../apis/activities";

export const fetchActivitiesList = createAsyncThunk(
  "activities/fetchActivities",
  async (
    {
      page,
      pageSize,
      hour,
      days,
      includeEtd = false,
    }: {
      page: number;
      pageSize: number;
      hour: string | null;
      days: string | null;
      includeEtd?: boolean;
    },
    { rejectWithValue }
  ) => {
    try {
      const activityRes = await fetchActivities(page, pageSize, hour, days, includeEtd);
      return {
        data: activityRes.data, // Extract data properly
        total: activityRes.total,
      }; // Return the activities for the given page
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchBerthrotationDataByJobId = createAsyncThunk(
  "berthrotation/fetchBerthrotationById",
  async (
    { jobId }: { jobId: string }, // Only jobId is required
    { rejectWithValue }
  ) => {
    try {
      // Default values are set within the fetchBerthrotationByJobId function
      const response = await fetchBerthrotationByJobId(jobId);
      return response; // Ensure response contains necessary data
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);



